import request from "api/axiosClient";

export const getDataZalo = async (values) => {
    const result = await request({
        url: "zalo-notification-report/data-statistics",
        method: "POST",
        data: values
    });
    return result?.data;
}

export const getGraphicalZalo = async (values) => {
    const result = await request({
        url: "zalo-notification-report/graphical-statistics",
        method: "POST",
        data: values
    });
    return result?.data;
}